import React, { useState, useEffect } from "react";
import { fetchFaq } from "../utils/faqApi";
import { motion } from "framer-motion";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    fetchFaq().then((data) => setFaqs(data || []));
  }, []);

  return (
    <div className="container-fluid py-5 bg-light overflow-hidden">
      <div className="container p-0">
        <motion.div 
          className="text-center pb-2"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="section-title px-5">
            <span className="px-2">FAQ</span>
          </p>
          <h1 className="mb-4">Frequently Asked Questions</h1>
        </motion.div>
        <motion.div 
          className="row"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {faqs.map((faq, idx) => (
            <motion.div 
              className="col-md-6 mb-4" 
              key={faq.id || idx}
              variants={itemVariants}
            >
              <div className="card border-0 shadow-sm h-100 p-4 hover-shadow-lg transition-all">
                <h5 className="font-weight-bold text-primary mb-3">
                  <i className="fa fa-question-circle mr-2"></i>
                  {faq.question}
                </h5>
                <p className="m-0 text-muted">{faq.answer}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
